import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from 'civic-champs-translations/src'

/** @param {string} locale */
export function adminLocaleLabelKey(locale) {
  const primary = (locale || '').split('-')[0]
  if (SUPPORTED_LOCALES.includes(primary)) {
    return `language.${primary}`
  }
  return `language.${DEFAULT_LOCALE}`
}

export function resolveOrgAdminLocales(organization) {
  const rawSupported = organization?.supportedAdminLocales
  const supported = Array.isArray(rawSupported) && rawSupported.length ? [...rawSupported] : ['en']
  const filtered = supported.filter(locale => SUPPORTED_LOCALES.includes(locale))
  const normalizedSupported = filtered.length ? filtered : ['en']

  let defaultLocale = organization?.defaultAdminLocale
  if (!defaultLocale || !normalizedSupported.includes(defaultLocale)) {
    defaultLocale = normalizedSupported[0]
  }

  return { supportedAdminLocales: normalizedSupported, defaultAdminLocale: defaultLocale }
}

export function pickAllowedAdminLocale(preferred, organization) {
  const { supportedAdminLocales, defaultAdminLocale } = resolveOrgAdminLocales(organization)
  const primary = (preferred || '').split('-')[0]
  if (primary && supportedAdminLocales.includes(primary)) {
    return primary
  }
  return defaultAdminLocale
}
